import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  AfterViewInit,
} from '@angular/core';
import { AppComponent } from 'src/app/app.component';
declare var $;
import { NavService } from 'src/app/_services/nav.service';
import {
  NgbdSortableHeader,
  SortColumn,
  SortDirection,
  SortEvent,
} from './sortable.directive';
import { SortService } from 'src/app/_services/sort.service';
import { DlpReportService } from 'src/app/_services/dlpReport.service';
import { pickBy, identity } from 'lodash';
import { CompanyService } from 'src/app/_services/company.service';
import { IrmReportService } from 'src/app/_services/irmReport.service';
import { log } from 'console';
import { ToastrService } from 'src/app/_services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PopupSensitiveInformationType } from './popup-sensitive-infomation-types/popup-sensitive-infomation-types.component';
interface Report {
  date: string;
  action: string;
  user: string;
  departament: string;
  label: string;
  priority: string;
  elem: number;
  opc: string;
}

@Component({
  selector: 'app-informes-dlp',
  templateUrl: './informes-dlp.component.html',
  styleUrls: ['./informes-dlp.component.css'],
})
export class InformesDLPComponent implements OnInit {
  data: { title: 'Informes' };
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  user: string;
  selectedActions: any[] = [];
  selectedDeptos: any[] = [];
  selectedPriorities: any[] = [];
  minDate: any;
  maxDate: any;
  prueba: any;
  sortState: any;
  REPORTS: Report[] = [];
  reports: any = [];
  page = 1;
  pageSize = 10;
  collectionSize = this.REPORTS.length;
  sortColumn: SortColumn;
  sortDirection: SortDirection;
  areFiltersCollapsed = true;
  isLoading: boolean = true;
  filters: any;
  actions: any[] = [];
  labels: any[] = [];
  labelsName: any[] = [];
  departments: any[] = [];
  selectedLabels: any[] = [];
  priorities: any[] = [];
  maxLength: number = 30;
  todasLasOpciones: [] = [];
  protected ngbModalRef: NgbModalRef;

  // tslint:disable-next-line: max-line-length
  constructor(
    private appComponent: AppComponent,
    private navService: NavService,
    public sortService: SortService,
    public dlpReportService: DlpReportService,
    private toastrService: ToastrService,
    public companyService: CompanyService,
    public irmReportService: IrmReportService,
    private translate: TranslateService,
    private modalService: NgbModal
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    this.isLoading = true;
    // this.authService.isAuthenticated();
    const today = new Date();
    this.maxDate = today;
    this.minDate = new Date(today);
    this.minDate.setDate(this.minDate.getDate() - 7);
    this.setFilters();
    this.getActions();
    this.getDepartments();
    this.getPolicies();

    this.selectedNavItem({
      parent: 'record.report',
      child: 'record.dpo',
      description: 'pageDescriptions.dlp',
    });
  }

  formatDate(selectedDate: Date): string {
    const day = selectedDate.getDate().toString().padStart(2, '0');
    const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
    const year = selectedDate.getFullYear().toString().substring(2);

    return `${day}.${month}.${year}`;
  }

  complete(numero) {
    return numero < 10 ? `0${numero}` : numero;
  }

  formatDateTable(date): string {
    const fecha = new Date(date);

    const dia = fecha.getUTCDate();
    const mes = fecha.getUTCMonth() + 1;
    const anio = fecha.getUTCFullYear();
    const horas = fecha.getUTCHours();
    const minutos = fecha.getUTCMinutes();
    const segundos = fecha.getUTCSeconds();

    return `${this.complete(dia)}/${this.complete(
      mes
    )}/${anio}, ${this.complete(horas)}:${this.complete(
      minutos
    )}:${this.complete(segundos)}`;
  }

  setFilters() {
    const filters = {
      mail: this.user,
      type:
        this.selectedActions?.length > 1
          ? [this.selectedActions]
          : this.selectedActions,
      department:
        this.selectedDeptos?.length > 1
          ? [this.selectedDeptos]
          : this.selectedDeptos,
      policy:
        this.selectedPriorities?.length > 1
          ? [this.selectedPriorities]
          : this.selectedPriorities,
      dateBegin: this.minDate && this.formatDate(this.minDate),
      dateEnd: this.maxDate && this.formatDate(this.maxDate),
    };
    this.filters = {
      ...filters,
      sort: this.sortState?.sort,
      order: this.sortState?.order,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.refreshReports();
  }

  cleanFilters() {
    this.user = undefined;
    this.selectedActions = undefined;
    this.selectedDeptos = undefined;
    this.selectedPriorities = undefined;
    this.minDate = undefined;
    this.maxDate = undefined;
    this.filters = undefined;
    this.filters = {
      ...this.filters,
      sort: this.sortState?.sort,
      order: this.sortState?.order,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.refreshReports();
  }

  refreshReports() {
    this.isLoading = true;
    this.dlpReportService
      .getAllDlpReports(this.page, this.pageSize, this.filters)
      .subscribe((res) => {
        this.collectionSize = res.body['total'];
        this.reports = res.body['results'];
        this.isLoading = false;
      });
  }

  getDepartments() {
    this.companyService.getDepartments().subscribe((res) => {
      this.departments = res.body.slice(0, 42);
      this.todasLasOpciones = res.body;
      this.departments = this.todasLasOpciones.slice(0, 20);
    });
  }

  getPolicies() {
    this.dlpReportService.getPolicies().subscribe((res) => {
      this.priorities = res?.body;
    });
  }

  cargarMasOpciones() {
    // Carga más opciones a 'opcionesPaginadas' al hacer scroll o al presionar un botón
    const inicio = this.departments.length;
    const fin = inicio + 20;
    this.departments = this.departments.concat(
      this.todasLasOpciones.slice(inicio, fin)
    );
  }

  getActions() {
    this.dlpReportService.getTypes().subscribe((res) => {
      this.actions = res.body;
    });
  }

  generateGeneralIrmReport() {
    let filters = {
      ...this.filters,
    };
    if (filters.type) {
      filters = {
        ...this.filters,
        type: this.filters?.type,
      };

      delete filters.type;
    }
    this.toastrService.info(this.translate.instant('onProcessGeneratngReport'));
    this.dlpReportService
      .generateGeneralDlpReport(filters, this.translate.currentLang)
      .subscribe(
        (res) => {},
        (error) => {
          this.toastrService.error(this.translate.instant('errorReport'));
        }
      );
  }

  generateEvoDlpReport() {
    let filters = {
      ...this.filters,
    };
    if (filters.type) {
      filters = {
        ...this.filters,
        type: this.filters?.type,
      };

      delete filters.type;
    }
    this.toastrService.info(this.translate.instant('onProcessGeneratngReport'));
    this.dlpReportService
      .generateEvoDlpReport(filters, this.translate.currentLang)
      .subscribe(
        (res) => {},
        (error) => {
          this.toastrService.error(this.translate.instant('errorReport'));
        }
      );
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.sortColumn = column;
    this.sortDirection = direction;

    if (this.sortDirection !== '') {
      this.filters = {
        ...this.filters,
        sort: this.sortColumn,
        order: this.sortDirection,
      };
      this.sortState = {
        sort: this.sortColumn,
        order: this.sortDirection,
      };
    } else {
      delete this.filters.sort;
      delete this.filters.order;
      this.sortState = undefined;
    }
    this.refreshReports();
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }

  cutString(string) {
    if (string === '' || string === null) return '';
    if (string.length <= this.maxLength) {
      return string;
    } else {
      return string.substr(0, this.maxLength) + '...';
    }
  }

  seeSensitiveData(sensitiveInformationTypes: any[]) {
    this.ngbModalRef = this.modalService.open(PopupSensitiveInformationType, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
      size: 'lg',
    });
    this.ngbModalRef.componentInstance.sensitiveInformationTypes =
      sensitiveInformationTypes;

    this.ngbModalRef.result.then();
  }
}
